// ---------------------------------------------------------------------------------------------------------------------
// inherit wordpress image alignment classes to parent elements
$.fn.inheritToParentElement = function( cssClass ) {
	return this.each(function() {
		var self = $(this);
		if (!self.siblings().length > 0) { // image has no siblings
			self.parent().addClass(cssClass + '-parent');
		}
	});
};

$(function(){
	cssClasses = [ 'alignleft', 'aligncenter', 'alignright' ];
	$.map( cssClasses, function( val, i ) {
		$('img.' + val).inheritToParentElement(val);
	});
});





// ---------------------------------------------------------------------------------------------------------------------
// scroll below fold
$(function() {
	$(window).on('scroll', function () {
		if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
			// you're at the bottom of the page
			$('html').addClass('scrolled-bottom');
		} else {
			$('html').removeClass('scrolled-bottom');
		}
		if ((window.scrollY) >= window.innerHeight) {
			// you're at the bottom of the page
			$('html').addClass('scrolled-below-fold');
		} else {
			$('html').removeClass('scrolled-below-fold');
		}
	});
});



// ---------------------------------------------------------------------------------------------------------------------

// related pages

$(function(){

	$('.related-page .related-page-content .related-page-title').matchHeight({byRow: true});
	$('.related-page .related-page-content .related-page-excerpt').matchHeight({byRow: false});
	$('.related-page .related-page-content .related-page-link').matchHeight({byRow: false});

});


// ---------------------------------------------------------------------------------------------------------------------